import styled, { css } from 'styled-components'

type InputBlockProps = {
  error?: string
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
  disabled?: boolean
  hasPrefixIcon?: boolean
}

export const Base = styled.div``

export const InputBlock = styled.div<InputBlockProps>`
  display: flex;
  align-items: center;
  min-height: 54px;
  box-sizing: border-box;
  font-size: 14px;
  border-radius: 2px;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  padding-left: ${props => (props.hasPrefixIcon ? '24px' : 0)};
`
export const PrefixIconWrapper = styled.div`
  margin: 0;
  max-width: 14px;
  max-height: 14px;

  svg {
    max-width: 100%;
    max-height: 100%;
  }
`

export const Input = styled.input`
  border: none;
  outline: none;
  margin: 0;
  background: transparent;
  width: 100%;
  height: 100%;
  padding-left: 20px;
  color: #000000;
  box-sizing: border-box;
  &::placeholder {
    color: #ebebeb;
  }
`
export const ClearButton = styled.button`
  background: #ebebeb;
  border-radius: 55px;
  width: 15px;
  height: 15px;
  border: none;
  position: relative;
  margin-right: 20px;
  /* background-image: url('/svgs/searchIcon.svg'); */
  ::after {
    content: 'x';
    color: #ffffff;
    position: absolute;
    display: block;
    top: -4px;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    height: 15px;
    width: 15px;
    cursor: pointer;
  }
`
